
import _forEach from 'lodash/forEach'
import vSelect from "vue-select";
import track from "../../../components/track";

const form = new Vue({
    el: '#energia_form',

    components: {
        vSelect
    },

    data() {
        return {
            form: {
                name: '',
                phone: '',
                email: '',
                entity: null,
                street: null,
                number: null,
                status: '',
                terms: false,
            },
            default: {
                name: '',
                phone: '',
                email: '',
                entity: null,
                street: null,
                number: null,
                terms: false,
            },
            validation: {
                name: 'required',
                phone: 'required',
                email: 'required',
                entity: 'required',
                street: 'required',
                number: 'required',
            },
            errors: {
                name: false,
                phone: false,
                email: false,
                entity: false,
                street: false,
                number: false,
                terms: false,
            },
            query: null,
            streetQuery: null,
            numberQuery: null,
            debounceEntities: null,
            debounceStreets: null,
            debounceNumbers: null,
            gis: {
                entities: [],
                streets: [],
                numbers: [],
            },
        }
    },
    methods: {
        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'phone'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    if(!phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }

                if(key === 'email'){
                    var emailRGEX = /^.+@.+$/;
                    var emailResult = emailRGEX.test(this.form[key]);
                    if(!emailResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }
                if(key === 'name'){
                    if(!this.form[key].length){
                        this.errors[key] = true
                        hasErrors = true
                    }
                }

            })
            this.errors.terms = false
            if(!this.form.terms){
                console.log('error terms');
                this.errors.terms = true
                hasErrors = true
            }

            if(hasErrors)
                return false

            return true
        },

        fetchEntities(value) {
            if (!value || value.length <=2) {
                this.gis.entities = []
                return;
            }
            clearTimeout(this.debounceEntities);
            let type = 'ent';
            this.debounceEntities = this.fetch(value, type);
        },
        fetchStreets(value) {
            if (!value || value.length <=2) {
                this.gis.streets = []
                this.numberQuery = null
                return;
            }
            clearTimeout(this.debounceStreets);
            let type = 'road';
            this.debounceStreets = this.fetch(value, type, this.query.code);
        },
        fetchNumbers(value) {
            if (!value || value.length <=0) {
                this.gis.numbers = []
                return;
            }
            clearTimeout(this.debounceNumbers);
            let type = 'num';
            if(this.streetQuery.code === '0000'){
                this.gis.numbers = [{ label: value,  code: '0000', level: '0000' }]
            }
            else this.debounceNumbers = this.fetch(value, type, this.streetQuery.code);
        },
        fetch(value, type, code = null) {
            return setTimeout(async () => {
                try {
                    let dataInfo = {
                        type: type,
                        name: value,
                        coverage_type: 'new'
                    }
                    if (type === 'road') {
                        dataInfo.municipality_id = code
                    } else if (type === 'num') {
                        dataInfo.road_id = code
                    }
                    let res = await axios.post('/coverage/search', dataInfo)
                    const data = res.data?.data ?? [];

                    if (type === 'ent') {
                        this.gis.entities = data.map(item => ({ label: item.n, code: item.c, e_code: item.ec, level: item.l }));
                    } else if (type === 'road') {
                        if(data.length === 0){
                            this.gis.streets = [{ label: value,  code: '0000', level: '0000' }]
                        }else {
                            this.gis.streets = data.map(item => ({ label: item.n,  code: item.c, level: item.ec }));
                        }
                    } else if (type === 'num'){
                        let isInArray = false;
                        data.forEach(el => {
                            if(el.n === value){
                                isInArray = true;
                                return;
                            }
                        })
                        if(!isInArray){
                            this.gis.numbers = [{ label: value,  code: '0000', level: '0000' }]
                        }else {
                            this.gis.numbers = data.map(item => ({ label: item.n,  code: item.c, level: item.rc }));
                        }
                    }
                } catch (e) {
                    console.error(e.message)
                    this.gis.entities = [];
                    this.gis.streets = [];
                    this.gis.numbers = [];
                }
            }, 250);
        },

        async submit(){
            this.form.entity = this.query
            this.form.street = this.streetQuery
            this.form.number = this.numberQuery
            console.log(this.form)
            if(!this.validateInputs()){
                return false
            }

            try {
                let params = {
                    name: this.form.name,
                    email: this.form.email,
                    municipality_code: this.form.entity.code,
                    entity_name: this.form.entity.label,
                    entity_code: this.form.entity.e_code,
                    entity_level: this.form.entity.level,
                    street_code: this.form.street.code,
                    street_name: this.form.street.label,
                    number_code: this.form.number.code,
                    number_name: this.form.number.label,
                    coverage_type: 'new',
                }

                let res = await axios.post('/coverage/check', params)
                this.form.status = res.data.data?.status ?? null
                this.address = res.data.data?.address ?? null

            } catch (e) {
                this.status = 'unavailable';
                console.log("error", e.message)
                console.log(e.response.data.errors)
            }
            this.form.entity = this.form.entity.label
            this.form.street = this.form.street.label
            this.form.number = this.form.number.label

            console.log(this.form);
            try {
                let params = {
                    name: this.form.name,
                    email: this.form.email,
                    phone: this.form.phone,
                    entity: this.form.entity,
                    street: this.form.street,
                    number: this.form.number,
                    status: this.form.status,
                    terms: this.form.terms
                }

                let res = await axios.post('/landing-energia/landing', params);
                console.log(window.location.href);

                // TODO mirar url per enviar al thankyou amb l'idioma que toca
                window.location.href = "/landing-energia-gracies?form="+ res.data.form +"&name="+res.data.name;
            } catch (e) {
                console.log("error", e.message)
                console.log(e.response.data.errors)
            }
            // $("#energia_form").submit();
        }
    },
    watch: {
        status: function (newValue, oldValue){
            if(newValue){
                this.$refs.options.style.display = 'block'
            }else{
                this.$refs.options.style.display = 'none'
            }
        },
        'query': function(newValue, oldValue){
            console.log(newValue)
            if(newValue){
                $('.coverage-street').removeClass('no-pointed');
            }else{
                $('.coverage-street').addClass('no-pointed');
                $('.coverage-number').addClass('no-pointed');
                this.streetQuery = null
                this.numberQuery = null
            }
        },
        'streetQuery': async function (newValue, oldValue) {
            if (newValue) {
                let dataInfo = {
                    type: 'allNum',
                    name: newValue.code,
                    id: this.streetQuery.code,
                    coverage_type: 'new'
                }
                $('.coverage-number').removeClass('no-pointed');
                let res = await axios.post('/coverage/search', dataInfo);
                console.log(res)
                const data = res.data?.data ?? [];
                if (data.length === 1){
                    this.numberQuery = {
                        label: data[0].n,
                        code: data[0].c,
                        level: data[0].rc
                    }
                }else if(data.length >= 2){
                    this.gis.numbers = data.map(item => ({ label: item.n,  code: item.c, level: item.rc }));
                }
            } else {
                $('.coverage-number').addClass('no-pointed');
                this.numberQuery = null
            }
        }
    },
});

